import { render, staticRenderFns } from "./IntroDialog.vue?vue&type=template&id=2a905769&"
import script from "./IntroDialog.vue?vue&type=script&lang=js&"
export * from "./IntroDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QCarousel,QCarouselSlide,QImg,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QCarousel,QCarouselSlide,QImg,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
